module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/Hero Image-4e6719346d0bb2af.png"+" 820w",
        images: [{path: __webpack_public_path__ + "assets/images/Hero Image-4e6719346d0bb2af.png",width: 820,height: 1168}],
        src: __webpack_public_path__ + "assets/images/Hero Image-4e6719346d0bb2af.png",
        toString: function(){return __webpack_public_path__ + "assets/images/Hero Image-4e6719346d0bb2af.png"},
        
        width: 820,
        height: 1168
      }